import React,{Fragment} from "react";
import "./App.css";
import routers from "./routers";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast_config } from "./utils/constants";
import { useIdleTimer } from "react-idle-timer";
import { useDispatch } from "react-redux";
import { userActions } from "./context/reducers/user";
import 'react-phone-input-2/lib/style.css';

function App() {
  const dispatch = useDispatch();

	const handleOnIdle = () => {
    // if(isLoggedIn) {
    dispatch(userActions.logout());
    window.location.href = "/";
    // }
  };

	useIdleTimer({
		timeout: 1000 * 60 * 60, // 1 hour
		onIdle: handleOnIdle,
		debounce: 500
	});
	return (
    <Fragment>
      {/* <BrowserRouter> */}
      {/* <Elements stripe={stripePromise}> */}
        <RouterProvider router={routers} />
        <ToastContainer {...toast_config} />
      {/* </Elements> */}
      {/* </BrowserRouter> */}
    </Fragment>
  );
}

export default App;
